import { trackAdjust } from "@otto-ec/apps-api/thirdpartytracking";

function getEventName(android: string, ios: string) {
  return {
    eventName: {
      android: android,
      ios: ios,
    },
  };
}

function contentPageAdjustEvent(sitePath: string) {
  const eventName = getEventName("cyv1b3", "pcv0sa");
  const productTracking = {
    partnerParameters: {
      sitePath: sitePath,
    },
  };

  return { ...eventName, ...productTracking };
}

const DUNDEE_PAGES = ["Produktliste", "Suchergebnisseite"];

export function trackAdjustEventForPage(sitePath: string) {
  const avContent: HTMLElement | null = document.getElementById("avContent");
  if (avContent) {
    const pageType: string = avContent.dataset.pt || "";

    if (DUNDEE_PAGES.includes(pageType)) return;

    trackAdjust(contentPageAdjustEvent(sitePath));
  }
}

let reptileAppsTrackingInitialized = false;

/**
 *
 */
export function registerAppAdjustTracking(sitePath?: string) {
  /*                                   */
  if (reptileAppsTrackingInitialized) {
    return;
  }
  reptileAppsTrackingInitialized = true;

  /*                                                */
  trackAdjustEventForPage(sitePath || window.location.href);
}
